module.exports = __webpack_public_path__ + "media/images/application2/TalkCard__top__a-fcb6f2fbc4d7162fbea95b0d6048605e.svg";